import { render, staticRenderFns } from "./ClientsDistributionBar.vue?vue&type=template&id=03378fd8"
import script from "./ClientsDistributionBar.vue?vue&type=script&lang=js"
export * from "./ClientsDistributionBar.vue?vue&type=script&lang=js"
import style0 from "./ClientsDistributionBar.vue?vue&type=style&index=0&id=03378fd8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports